import { SalesforceSaveObjectsConfig } from 'ihub/common';
import { AdvancedTourStep } from '../shared-types';
import { TaskTourProps } from './task-tour-props';

export function getSalesforceSaveObjectsTourSteps({
	defaultStyles,
	microTaskConfigType,
}: Readonly<TaskTourProps>): AdvancedTourStep[] {
	if (!microTaskConfigType) return [];
	const config = microTaskConfigType as SalesforceSaveObjectsConfig;

	return [
		{
			id: 'client-id',
			selector: '[data-tour="client-id"]',
			content:
				'Required: The Salesforce client id. Note that this value is populated via a Flow Parameter of type Passphrase properties',
		},
		{
			id: 'client-secret',
			selector: '[data-tour="client-secret"]',
			content:
				'Required: The Salesforce client secret. Note that this value is populated via a Flow Parameter of type Passphrase properties',
		},
		{
			id: 'instance-url',
			selector: '[data-tour="instance-url"]',
			content:
				'Required: The Salesforce instance URL. Note that this property supports expressions. Please see Expression Selector for more information.',
		},
		{
			id: 'object-type',
			selector: '[data-tour="object-type"]',
			content:
				'Required: The list of supported object types supported by the connected Salesforce instance. Note that this dropdown will only populate once valid connection details have been provided.',
		},
		{
			id: 'external-id',
			selector: '[data-tour="external-id"]',
			content: 'Required: The field on the object that should be used as the ID.',
		},
		...(config.fieldMappings.length > 0
			? [
					{
						id: 'field-mappings',
						selector: '[data-tour="field-mappings"]',
						content: 'The fields that should be extracted from the input objects to be sent.',
					},
					{
						id: 'retry-delay',
						selector: '[data-tour="retry-delay"]',
						content: 'A delay time in ms. This will set the time to wait between retries.',
					},
					{
						id: 'auto-map-fields',
						selector: '[data-tour="auto-map-fields"]',
						content:
							'This is used to generate all field mappings that exist on the selected object type in Salesforce.',
					},
					{
						id: 'add-mapping-field',
						selector: '[data-tour="add-mapping-field"]',
						content:
							'This is used to add a single field mapping. Field mappings are used to choose which properties will be saved when creating or updating objects in Salesforce.',
					},
					{
						id: 'incoming-object-field',
						selector: '[data-tour="incoming-object-field"]',
						content: 'Required: The field value that will be taken from the input record.',
					},
					{
						id: 'upsert-object-field',
						selector: '[data-tour="upsert-object-field"]',
						content:
							'Required: The destination field on the Salesforce object the value will be assigned to.',
					},
				]
			: []),
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
